<template>
  <div>
    <q-expansion-item
      v-model="expandTypes['nullifies']"
      class="q-my-sm"
      :class="{ 'q-px-sm q-py-sm border-open': bordered }"
      :style="bordered ? 'margin-bottom: 24px;' : ''"
      dense
      header-class="q-px-none"
      :disable="changesCounts.nullifies === 0"
    >
      <template #header>
        <div class="row full-width q-gutter-x-xs items-center">
          <div class="text-body-em">
            Removes Item ({{ changesCounts.nullifies }})
          </div>
          <div
            v-if="bordered"
            class="text-body1"
          >
            This Item will be removed from the following on archive
          </div>
        </div>
      </template>
      <template #default>
        <div
          class="column q-ma-xs"
        >
          <div
            v-for="association in nullifies"
            :key="`nullifies-${association.name}`"
            class="column q-ml-md"
          >
            <div class="text-body1">
              {{ $_.startCase(association.label) }} ({{ association.changes.length }})
            </div>
            <ul class="text-body1 q-mt-none q-mb-sm q-pl-lg">
              <li
                v-for="change in association.changes"
                :key="`${association.name}-${change.id}`"
              >
                <div class="row items-center justify-start q-gutter-x-xs q-ml-xs">
                  <div class="col row items-center q-gutter-x-xs">
                    <div>
                      {{ change.label }}
                    </div>
                    <div class="text-grey-8">
                      (ID {{ change.id }})
                    </div>
                  </div>
                  <router-link
                    v-if="!hideView"
                    :to="changeRoute(change)"
                    class="row items-center q-gutter-x-xs text-primary text-decoration-none"
                    style="font-size: 0.9rem;
                    "
                  >
                    <div>View</div>
                    <q-icon
                      name="arrow_forward"
                      size="xs"
                    />
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </q-expansion-item>
    <q-expansion-item
      v-model="expandTypes['warns']"
      class="q-mt-sm"
      :class="{ 'q-px-sm q-py-sm border-open': bordered }"
      dense
      header-class="q-px-none"
      :disable="changesCounts.warns === 0"
    >
      <template #header>
        <div class="row full-width q-gutter-x-xs items-center">
          <div class="text-body-em">
            Warnings ({{ changesCounts.warns }})
          </div>
          <div
            v-if="bordered"
            class="text-body1"
          >
            This Item will be retained on the following after archive
          </div>
        </div>
      </template>
      <template #default>
        <div
          class="column q-ma-xs"
        >
          <div
            v-for="association in warns"
            :key="`warns-${association.name}`"
            class="column q-ml-md"
          >
            <div class="text-body1">
              {{ $_.startCase(association.label) }} ({{ association.changes.length }})
            </div>
            <ul class="text-body1 q-mt-none q-mb-sm q-pl-lg">
              <li
                v-for="change in association.changes"
                :key="`${association.name}-${change.id}`"
              >
                <div class="row items-center justify-start q-gutter-x-xs q-ml-xs">
                  <div class="col row items-center q-gutter-x-xs">
                    <div>
                      {{ change.label }}
                    </div>
                    <div class="text-grey-8">
                      (ID {{ change.id }})
                    </div>
                  </div>
                  <router-link
                    v-if="!hideView"
                    :to="changeRoute(change)"
                    class="row items-center q-gutter-x-xs text-primary text-decoration-none"
                    style="font-size: 0.9rem;"
                  >
                    <div>View</div>
                    <q-icon
                      name="arrow_forward"
                      size="xs"
                    />
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </q-expansion-item>
  </div>
</template>

<script>
import { computeCollectionVariableName } from 'src/models/model/utils/collection-utils'

export default {
  name: 'ArchiveConfirmationSection',
  props: {
    hideView: {
      type: Boolean,
      default: false,
      required: false
    },
    warns: {
      type: Array,
      default: () => ([]),
      required: false
    },
    nullifies: {
      type: Array,
      default: () => ([]),
      required: false
    },
    bordered: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      expandTypes: {
        warns: false,
        nullifies: true
      },
      expands: {
        warns: {},
        nullifies: {}
      }
    }
  },
  computed: {
    changesCounts () {
      return {
        warns: _(this.warns).map('changes').flatten().value().length,
        nullifies: _(this.nullifies).map('changes').flatten().value().length
      }
    }
  },
  methods: {
    changeRoute (change) {
      return {
        name: 'admin:settings-category-name-id',
        params: {
          category: 'archiving',
          name: _.kebabCase(computeCollectionVariableName(change.type)),
          id: change.id
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.q-expansion-item :deep(.small-expansion-toggle >.q-item__section--avatar) {
  padding-right: 0;
  min-width: 0;
}

.border-open {
  border: 1px solid #D5D5D5;
  border-radius: 6px;
}
</style>
